import BaseModelAPI from '../BaseModelAPI';

export default class ControlCardTypeList extends BaseModelAPI {

	static entity = 'controlcardtypelist'
	static entityName = 'controlcardtype';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
